import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GroupsPage } from '@/features/access/groups/groups-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Les groupes se rejoignent depuis les membres de l'organisation : même entrée de navigation. */
export const Route = createFileRoute('/$tenant/groups/')({ component: GroupsRoute });

function GroupsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[{ label: t('access.members.title') }, { label: t('access.groups.title') }]}
    >
      <GroupsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
